module.exports = __webpack_public_path__ + "img/0.f8d333ee.jpg";